import List from "@mui/material/List/List";
import ListItem from "@mui/material/ListItem/ListItem";
import ListItemButton from "@mui/material/ListItemButton/ListItemButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import IconProvider from "../../components/icons/IconProvider";
import { SimulatorContext, ISimulatorContext } from "../../context/SimulatorProvider";
import { StepperContext } from '../../context/StepperProvider';
import { SimulationType } from "../../data/Simulation";
import "./SimulationMenu.css";

function SimulationMenu() {
    const { t } = useTranslation();
    const firstRender = useRef(true);
    const { setPreviousDisabled, setNextDisabled } = useContext(StepperContext);
    const [selectedSimulationType, setSelectedSimulationType] = useState<SimulationType>(SimulationType.Time);
    const { setUserSimulationType } = useContext(SimulatorContext) as ISimulatorContext

    const selectSimulationType = (simulationType: SimulationType) => {
        setSelectedSimulationType(simulationType);
        setUserSimulationType(simulationType);
    }

    useEffect(() => {
        if (firstRender.current) {
            setUserSimulationType(SimulationType.Time);
            setPreviousDisabled(false)
            setNextDisabled(false)
            firstRender.current = false
        }
    })

    return (
        <Stack textAlign="center" mb={2}>
            <Typography variant="body1">
                {t("simulation-menu.simulation-label")}
            </Typography>
            <List className="simulation-type-list" disablePadding>
                <ListItem disablePadding disableGutters>
                    <ListItemButton
                        selected={selectedSimulationType === SimulationType.Time}
                        onClick={() => selectSimulationType(SimulationType.Time)}
                        className="simulation-type-button"
                        defaultChecked
                    >
                        <div className="simulation-type-content">
                            <IconProvider id="chrono" color={selectedSimulationType === SimulationType.Time ? "red-filter" : "grey-filter"} size="large" />
                            <Typography variant="subtitle2" color={selectedSimulationType === SimulationType.Time ? "secondary" : "primary"}>
                                {t("simulation-menu.simulation-time-label")}
                            </Typography>
                        </div>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding disableGutters>
                    <ListItemButton
                        selected={selectedSimulationType === SimulationType.Battery}
                        onClick={() => selectSimulationType(SimulationType.Battery)}
                        className="simulation-type-button"
                    >
                        <div className="simulation-type-content">
                            <div className="rotate-90">
                                <IconProvider id="battery" color={selectedSimulationType === SimulationType.Battery ? "red-filter" : "grey-filter"} size="large" />
                            </div>
                            <Typography variant="subtitle2" color={selectedSimulationType === SimulationType.Battery ? "secondary" : "primary"}>
                                {t("simulation-menu.simulation-battery-label")}
                            </Typography>
                        </div>
                    </ListItemButton>
                </ListItem>
            </List>
        </Stack>
    )
}

export default SimulationMenu;